"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateFunction = void 0;
exports.fdatetime = fdatetime;
exports.fdatetimeUTC = fdatetimeUTC;
exports.fdatetimeUTCZ = fdatetimeUTCZ;
exports.simpleFormatDate = simpleFormatDate;
const lang_1 = require("./lang");
const padNumber_1 = require("./padNumber");
/**
 * formatuje datę i czas do formatu yyyy-MM-dd HH:mm:ss
 * @param dt data typu Date
 */
function fdatetime(dt, format, lang) {
    const lng = lang || (this === null || this === void 0 ? void 0 : this.lang) || lang_1.defaultLang.current;
    if (typeof dt === 'string') {
        dt = new Date(dt);
    }
    if (!isNaN(dt.getTime())) {
        let func = exports.formatDateFunction[format || 'yyyy-MM-dd HH:mm:ss'];
        if (func === undefined) {
            func = createFormatDateFunction(format || 'yyyy-MM-dd HH:mm:ss');
        }
        return func(dt, lng);
    }
    return '';
    // return fdate(dt) + ' ' + ftime(dt);
}
/**
 * formatuje datę i czas utc do formatu yyyy-MM-dd HH:mm:ss
 * @param dt data typu Date
 */
function fdatetimeUTC(dt) {
    return (dt.getUTCFullYear() +
        '-' +
        (0, padNumber_1.padNumber)(dt.getUTCMonth() + 1) +
        '-' +
        (0, padNumber_1.padNumber)(dt.getUTCDate()) +
        ' ' +
        (0, padNumber_1.padNumber)(dt.getUTCHours()) +
        ':' +
        (0, padNumber_1.padNumber)(dt.getUTCMinutes()) +
        ':' +
        (0, padNumber_1.padNumber)(dt.getUTCSeconds()));
}
/**
 * formatuje datę i czas utc do formatu yyyy-MM-ddTHH:mm:ssZ
 * @param dt data typu Date
 */
function fdatetimeUTCZ(dt) {
    return (dt.getUTCFullYear() +
        '-' +
        (0, padNumber_1.padNumber)(dt.getUTCMonth() + 1) +
        '-' +
        (0, padNumber_1.padNumber)(dt.getUTCDate()) +
        'T' +
        (0, padNumber_1.padNumber)(dt.getUTCHours()) +
        ':' +
        (0, padNumber_1.padNumber)(dt.getUTCMinutes()) +
        ':' +
        (0, padNumber_1.padNumber)(dt.getUTCSeconds()) +
        'Z');
}
function simpleFormatDate(dt) {
    return (dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        dt.getDate().toString().padStart(2, '0'));
}
function createFormatDateFunction(format) {
    const arr = [];
    const bformat = format;
    function ff(part, func) {
        let p = format.indexOf(part);
        while (p > -1) {
            arr[p] = func;
            let ins = '';
            for (let i = 0; i < part.length; i++) {
                ins += '^';
            }
            format = format.substring(0, p) + ins + format.substring(p + part.length);
            p = format.indexOf(part);
        }
    }
    for (const key in exports.formatDateFunction) {
        ff(key, exports.formatDateFunction[key]);
    }
    const funcText = [];
    for (let i = 0; i < format.length; i++) {
        if (arr[i]) {
            let ftext = arr[i].toString();
            const p = ftext.indexOf('=>');
            if (p > -1) {
                const attrs = ftext.substring(0, p).trim().replace('(', '').replace(')', '').split(',');
                ftext = ftext.substring(p + 2).trim();
                const dtval = attrs[0].trim();
                if (dtval !== 'dt7') {
                    ftext = ftext.replaceAll(dtval + '.', 'dt7.');
                }
                let langval = attrs[1];
                if (langval) {
                    langval = langval.trim();
                    if (langval !== 'lang7') {
                        ftext = ftext.replaceAll(langval + '.', 'lang7.');
                    }
                }
            }
            funcText.push(ftext);
        }
        else if (format[i] !== '^') {
            funcText.push('"' + format[i] + '"');
        }
    }
    const func = new Function('dt7,lang7', 'return ' + funcText.join('+'));
    exports.formatDateFunction[bformat] = func;
    return func;
}
exports.formatDateFunction = {
    'd.MM.yyyy': (dt7) => dt7.getDate() + '.' + (dt7.getMonth() + 1).toString().padStart(2, '0') + '.' + dt7.getFullYear(),
    'dd.MM.yyyy': (dt7) => dt7.getDate().toString().padStart(2, '0') +
        '.' +
        (dt7.getMonth() + 1).toString().padStart(2, '0') +
        '.' +
        dt7.getFullYear(),
    // 'yyyy-MM-dd': (dt: Date) => dt.getFullYear() + '-' + padNumber(dt.getMonth() + 1) + '-' + padNumber(dt.getDate()),
    'yyyy-MM-dd': simpleFormatDate,
    'MMMM yyyy': (dt7, lang7) => `${lang7.months[dt7.getMonth()]} ${dt7.getFullYear()}`,
    'MMM yyyy': (dt7, lang7) => `${lang7.monthsShort[dt7.getMonth()]} ${dt7.getFullYear()}`,
    'HH:mm:ss': (dt7) => `${dt7.getHours().toString().padStart(2, '0')}:${dt7.getMinutes().toString().padStart(2, '0')}:${dt7
        .getSeconds()
        .toString()
        .padStart(2, '0')}`,
    'dd.MM.yyyy HH:mm:ss': (dt7, lang7) => exports.formatDateFunction['dd.MM.yyyy'](dt7, lang7) + ' ' + exports.formatDateFunction['HH:mm:ss'](dt7, lang7),
    'yyyy-MM-dd HH:mm:ss': (dt7, lang7) => exports.formatDateFunction['yyyy-MM-dd'](dt7, lang7) + ' ' + exports.formatDateFunction['HH:mm:ss'](dt7, lang7),
    dddd: (dt7, lang7) => lang7.weekdays[dt7.getDay()],
    ddd: (dt7, lang7) => lang7.weekdaysShort[dt7.getDay()],
    dd: (dt7) => dt7.getDate().toString().padStart(2, '0'),
    d: (dt7) => dt7.getDate().toString(),
    DDDD: (dt7, lang7) => lang7.weekdays[dt7.getDay()],
    DDD: (dt7, lang7) => lang7.weekdaysShort[dt7.getDay()],
    DD: (dt7) => dt7.getDate().toString().padStart(2, '0'),
    D: (dt7) => dt7.getDate().toString(),
    MMMM: (dt7, lang7) => lang7.months[dt7.getMonth()],
    MMM: (dt7, lang7) => lang7.monthsShort[dt7.getMonth()],
    MM: (dt7) => (dt7.getMonth() + 1).toString().padStart(2, '0'),
    M: (dt7) => (dt7.getMonth() + 1).toString(),
    YYYY: (dt7) => dt7.getFullYear().toString(),
    YY: (dt7) => (dt7.getFullYear() % 100).toString().padStart(2, '0'),
    yyyy: (dt7) => dt7.getFullYear().toString(),
    yy: (dt7) => (dt7.getFullYear() % 100).toString().padStart(2, '0'),
    HH: (dt7) => dt7.getHours().toString().padStart(2, '0'),
    H: (dt7) => dt7.getHours().toString(),
    mm: (dt7) => dt7.getMinutes().toString().padStart(2, '0'),
    m: (dt7) => dt7.getMinutes().toString(),
    ss: (dt7) => dt7.getSeconds().toString().padStart(2, '0'),
    s: (dt7) => dt7.getSeconds().toString(),
    long: (dt7, lang7) => lang7.longDateFormatter(dt7)
};
//# sourceMappingURL=fdatetime.js.map